import { withStylePrefix } from '../common/withStylePrefix';
import { InputStepperComponent, inputStepperTemplate } from './InputStepper';
import styles from './InputStepper.styles.scss';
export const inputStepperDefinition = {
    baseName: 'input-stepper',
    template: inputStepperTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonInputStepper = InputStepperComponent.compose(inputStepperDefinition);
